import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ProductCategoriesSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const productCategories = [
    {
      title: language === 'fr' ? 'Débitmètres industriels' : 
             language === 'ar' ? 'عدادات التدفق الصناعية' : 
             'Industrial flowmeters',
      description: language === 'fr' 
        ? 'Solutions de mesure de débit précises pour les applications Pétrole, Gaz et Industrie, y compris les débitmètres à ultrasons, à effet vortex et à effet Coriolis.' 
        : language === 'ar' 
        ? 'حلول قياس التدفق الدقيقة للتطبيقات البتروكيماوية، بما في ذلك عدادات التدفق بالموجات فوق الصوتية وتأثير الدوامة وتأثير كوريوليس.' 
        : 'Precise flow measurement solutions for petrochemical applications, including ultrasonic, vortex, and Coriolis flowmeters.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      products: [
        language === 'fr' ? 'Débitmètres à ultrasons Transport PT878GC' : 
        language === 'ar' ? 'عدادات التدفق بالموجات فوق الصوتية Transport PT878GC' : 
        'Transport PT878GC Ultrasonic Flowmeters',
        
        language === 'fr' ? 'Débitmètres à effet vortex' : 
        language === 'ar' ? 'عدادات التدفق بتأثير الدوامة' : 
        'Vortex Flowmeters',
        
        language === 'fr' ? 'Débitmètres à ultrasons fixes DigitalFlow' : 
        language === 'ar' ? 'عدادات التدفق بالموجات فوق الصوتية الثابتة DigitalFlow' : 
        'DigitalFlow Fixed Ultrasonic Flowmeters'
      ]
    },
    {
      title: language === 'fr' ? 'Analyseurs de gaz' : 
             language === 'ar' ? 'محللات الغاز' : 
             'Gas analyzers',
      description: language === 'fr' 
        ? 'Instruments de haute précision pour l\'analyse des gaz industriels, la surveillance des émissions et le contrôle des processus.' 
        : language === 'ar' 
        ? 'أدوات عالية الدقة لتحليل الغازات الصناعية ومراقبة الانبعاثات والتحكم في العمليات.' 
        : 'High-precision instruments for industrial gas analysis, emissions monitoring, and process control.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      products: [
        language === 'fr' ? 'Chromatographes en phase gazeuse' : 
        language === 'ar' ? 'أجهزة كروماتوغرافيا الغاز' : 
        'Gas Chromatographs',
        
        language === 'fr' ? 'Analyseurs d\'oxygène paramagnétiques' : 
        language === 'ar' ? 'محللات الأكسجين المغناطيسية' : 
        'Paramagnetic Oxygen Analyzers',
        
        language === 'fr' ? 'Analyseurs utilisant le principe de thermo conductivité' : 
        language === 'ar' ? 'محللات تستخدم مبدأ التوصيل الحراري' : 
        'Thermal Conductivity Analyzers'
      ]
    },
    {
      title: language === 'fr' ? 'Analyseurs d\'humidité' : 
             language === 'ar' ? 'محللات الرطوبة' : 
             'Moisture analyzers',
      description: language === 'fr' 
        ? 'Solutions avancées pour la mesure précise de l\'humidité dans les gaz et les liquides, essentielles pour les processus industriels de qualité.' 
        : language === 'ar' 
        ? 'حلول متقدمة لقياس الرطوبة بدقة في الغازات والسوائل، وهي ضرورية لعمليات الجودة الصناعية.' 
        : 'Advanced solutions for accurate moisture measurement in gases and liquids, essential for quality industrial processes.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      products: [
        language === 'fr' ? 'Analyseurs d\'humidité à oxyde d\'aluminium' : 
        language === 'ar' ? 'محللات الرطوبة بأكسيد الألومنيوم' : 
        'Aluminum Oxide Moisture Analyzers',
        
        language === 'fr' ? 'Analyseurs de point de rosée portatifs' : 
        language === 'ar' ? 'محللات نقطة الندى المحمولة' : 
        'Portable Dew Point Analyzers',
        
        language === 'fr' ? 'Systèmes de surveillance d\'humidité en ligne' : 
        language === 'ar' ? 'أنظمة مراقبة الرطوبة عبر الإنترنت' : 
        'Online Moisture Monitoring Systems'
      ]
    },
    {
      title: language === 'fr' ? 'Systèmes de surveillance des processus' : 
             language === 'ar' ? 'أنظمة مراقبة العمليات' : 
             'Process monitoring systems',
      description: language === 'fr' 
        ? 'Solutions intégrées pour la surveillance en temps réel des paramètres critiques des processus, permettant un contrôle optimal et une efficacité accrue.' 
        : language === 'ar' 
        ? 'حلول متكاملة للمراقبة في الوقت الفعلي للمعلمات الحرجة للعملية، مما يتيح التحكم الأمثل وزيادة الكفاءة.' 
        : 'Integrated solutions for real-time monitoring of critical process parameters, enabling optimal control and increased efficiency.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      products: [
        language === 'fr' ? 'Systèmes de surveillance en ligne' : 
        language === 'ar' ? 'أنظمة المراقبة عبر الإنترنت' : 
        'Online Monitoring Systems',
        
        language === 'fr' ? 'Transmetteurs de processus multiparamètres' : 
        language === 'ar' ? 'أجهزة إرسال العمليات متعددة المعلمات' : 
        'Multiparameter Process Transmitters',
        
        language === 'fr' ? 'Solutions de surveillance à distance' : 
        language === 'ar' ? 'حلول المراقبة عن بعد' : 
        'Remote Monitoring Solutions'
      ]
    }
  ];

  return (
    <section className="section section-light" style={{ 
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF6B00' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        opacity: 0.5
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <h2 className="text-center fade-in" style={{ 
          fontSize: '2.5rem', 
          marginBottom: '1rem',
          position: 'relative',
          paddingBottom: '1.5rem',
          display: 'inline-block',
          textAlign: 'center'
        }}>
          {t('products.categories.title')}
          <span style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            backgroundColor: 'var(--assco-orange)',
            borderRadius: '2px'
          }}></span>
        </h2>
        
        <p className="subtitle text-center fade-in" style={{ 
          maxWidth: '800px',
          margin: '0 auto 4rem',
          fontSize: '1.125rem',
          color: 'var(--assco-gray-600)'
        }}>
          {language === 'fr' 
            ? 'Nous proposons une gamme complète de produits d\'instrumentation de haute qualité pour répondre à tous vos besoins de mesure et d\'analyse.' 
            : language === 'ar'
            ? 'نقدم مجموعة كاملة من منتجات القياس عالية الجودة لتلبية جميع احتياجات القياس والتحليل الخاصة بك.'
            : 'We offer a comprehensive range of high-quality instrumentation products to meet all your measurement and analysis needs.'}
        </p>
        
        {productCategories.map((category, index) => (
          <div 
            key={index}
            className="product-category fade-in"
            style={{
              marginBottom: index < productCategories.length - 1 ? '4rem' : 0,
              animationDelay: `${0.2 * index}s`
            }}
          >
            <div className="grid" style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(12, 1fr)', 
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div className={`col-span-4 md-col-span-12 ${index % 2 === 1 ? 'order-last md-order-first' : ''}`}>
                <div className="product-image" style={{ 
                  position: 'relative',
                  borderRadius: 'var(--radius-lg)',
                  overflow: 'hidden',
                  boxShadow: 'var(--shadow-lg)',
                  height: '300px',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* Product category image placeholder */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: index % 4 === 0 
                      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='white'/%3E%3Cpath d='M100,150 L100,250 M150,100 L150,250 M200,150 L200,250 M250,50 L250,250 M300,100 L300,250' stroke='%23d1d5db' stroke-width='10' fill='none'/%3E%3Ccircle cx='100' cy='150' r='10' fill='%23FF6B00'/%3E%3Ccircle cx='150' cy='100' r='10' fill='%23FF6B00'/%3E%3Ccircle cx='200' cy='150' r='10' fill='%23FF6B00'/%3E%3Ccircle cx='250' cy='50' r='10' fill='%23FF6B00'/%3E%3Ccircle cx='300' cy='100' r='10' fill='%23FF6B00'/%3E%3C/svg%3E")` 
                      : index % 4 === 1
                      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='white'/%3E%3Crect x='100' y='50' width='200' height='100' rx='10' fill='%23d1d5db'/%3E%3Crect x='150' y='170' width='100' height='80' rx='5' fill='%23d1d5db'/%3E%3Crect x='120' y='70' width='160' height='60' rx='5' fill='white'/%3E%3Ccircle cx='200' cy='210' r='20' fill='%23FF6B00' fill-opacity='0.5'/%3E%3C/svg%3E")`
                      : index % 4 === 2
                      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='white'/%3E%3Cpath d='M150,50 L100,150 L150,250 L250,250 L300,150 L250,50 Z' fill='%23d1d5db'/%3E%3Ccircle cx='200' cy='150' r='50' fill='white'/%3E%3Ccircle cx='200' cy='150' r='30' fill='%23FF6B00' fill-opacity='0.5'/%3E%3C/svg%3E")`
                      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='white'/%3E%3Ccircle cx='200' cy='150' r='100' fill='%23d1d5db' fill-opacity='0.3'/%3E%3Ccircle cx='200' cy='150' r='70' fill='%23d1d5db' fill-opacity='0.5'/%3E%3Ccircle cx='200' cy='150' r='40' fill='%23d1d5db' fill-opacity='0.7'/%3E%3Ccircle cx='200' cy='150' r='15' fill='%23FF6B00'/%3E%3C/svg%3E")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}></div>
                  
                  {/* Category icon overlay */}
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--assco-orange)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    boxShadow: 'var(--shadow-lg)'
                  }}>
                    <div style={{ transform: 'scale(0.8)' }}>
                      {category.icon}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-span-8 md-col-span-12">
                <h3 style={{ 
                  fontSize: '2rem', 
                  marginBottom: '1.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  {category.title}
                </h3>
                
                <p style={{ 
                  fontSize: '1.125rem', 
                  lineHeight: '1.7',
                  marginBottom: '2rem',
                  color: 'var(--assco-gray-700)'
                }}>
                  {category.description}
                </p>
                
                <div style={{ marginBottom: '2rem' }}>
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    marginBottom: '1rem',
                    color: 'var(--assco-gray-800)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {language === 'fr' ? 'Produits phares' : 
                     language === 'ar' ? 'المنتجات الرئيسية' : 
                     'Featured products'}
                  </h4>
                  
                  <ul style={{ 
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0
                  }}>
                    {category.products.map((product, idx) => (
                      <li 
                        key={idx}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          marginBottom: '0.75rem',
                          paddingLeft: language === 'ar' ? 0 : '1.5rem',
                          paddingRight: language === 'ar' ? '1.5rem' : 0,
                          position: 'relative'
                        }}
                      >
                        <div style={{
                          position: 'absolute',
                          left: language === 'ar' ? 'auto' : 0,
                          right: language === 'ar' ? 0 : 'auto',
                          top: '0.35rem',
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: 'var(--assco-orange)'
                        }}></div>
                        {product}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div>
                  <Link 
                    to="/contact" 
                    className="btn btn-primary"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    {language === 'fr' ? 'Demander plus d\'informations' : 
                     language === 'ar' ? 'طلب المزيد من المعلومات' : 
                     'Request more information'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px' }} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductCategoriesSection;
